import { CommonModule } from '@angular/common'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  ButtonModule,
  ModalVariantModule,
  NfFormsModule,
  RadioModule,
  ToastModule,
} from '@northfork/ng-basics'
import { CloseSessionModalComponent } from './components/modals/close-session-modal/close-session-modal.component'
import { CreateNewSessionModalComponent } from './components/modals/create-new-session/create-new-session-modal.component'
import { UncommittedChangesAutoRefreshModalComponent } from './components/modals/uncommitted-changes-auto-refresh/uncommitted-changes-auto-refresh-modal.component'
import { UncommittedChangesDetectedModalComponent } from './components/modals/uncommitted-changes-detected/uncommitted-changes-detected-modal.component'
import { SessionCardComponent } from './components/session-card/session-card.component'
import { SessionsDrawerComponent } from './components/sessions-drawer/sessions-drawer.component'
import { SessionsAppInitializerService } from './services/app-initializers/sessions-app-initializer.service'

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    NgbTooltipModule,
    NgbModalModule,
    NfFormsModule,
    GenericComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    RadioModule,
    ToastModule,
    ModalVariantModule,
    NgSelectModule,
  ],
  declarations: [
    SessionsDrawerComponent,
    SessionCardComponent,
    CreateNewSessionModalComponent,
    UncommittedChangesDetectedModalComponent,
    UncommittedChangesAutoRefreshModalComponent,
    CloseSessionModalComponent,
  ],
  exports: [SessionsDrawerComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (service: SessionsAppInitializerService) => {
        return () => service.init()
      },
      deps: [SessionsAppInitializerService],
      multi: true,
    },
  ],
})
export class SessionsModule {}
